import React from "react";
import { useTranslation } from "react-i18next";
import { Anchor, Group } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons";
import { useTabNavigate } from "../../hooks/useTabNavigate";

const MigrationBackLink = () => {
  const { t } = useTranslation();
  const tabNav = useTabNavigate();

  return (
    <Group>
      <Anchor
        size="sm"
        onClick={() => tabNav.open({ pathname: "/management/dataMigration" })}
        sx={{ display: "inline-flex", alignItems: "center", gap: 4 }}
      >
        <IconArrowLeft size={14} />
        {t("Back to sources")}
      </Anchor>
    </Group>
  );
};

export default MigrationBackLink;
